import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import globalEnglish from '../local/locales/en/global.json'
import globalFrench from '../local/locales/fr/global.json'
const debug = `${process.env.REACT_APP_I18N_DEBUG}`
const debugFlag = ['1', 'yes', 'true'].includes(debug)

const resources = {
  en: {
    global: globalEnglish,
  },
  fr: {
    global: globalFrench,
  },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    appendNamespaceToCIMode: true,
    saveMissing: false,
    debug: debugFlag,
    interpolation: {
      escapeValue: false,
      formatSeparator: ',',
      prefix: '{{',
      suffix: '}}',
    },
    defaultNS: 'components',
    react: {
      wait: true,
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['a', 'br', 'strong', 'b', 'i'],
    },
  })

export default i18n
